import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import 'dayjs/locale/es';

dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(relativeTime);

// The backoffice is Spanish-only. This used to be set from the Redux locale slice; with that layer gone
// it is pinned here, so a locale-sensitive token (`MMMM`, `.humanize()`) cannot silently fall back to
// dayjs's English default. The formats in `constants.ts` are numeric, so nothing renders differently today.
dayjs.locale('es');
// utc + timezone enable formatting stored UTC instants in the platform timezone (see date-utils.formatAdminInstant).
dayjs.extend(utc);
dayjs.extend(timezone);
